import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import { ToastContainer, toast } from 'react-toastify';
import {CircleLoader} from 'react-spinners';
import { Oval } from  'react-loader-spinner'
import tclogo from '../Assets/Images/tc.png'

const Tcsectionmain = () => {

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const[pop,setpop] = useState(false);
  const [data,setData]= useState([])
 
 useEffect(()=>{
   document.getElementById('remove').style.display = "none";
   document.getElementById('Tc-section-head').style.display = "none";
   document.getElementById('sectionspan').innerHTML = "";
  setpop(true);
  getUser();
  getSectionData();
  GetTransactionhistory()
  GetTermscondition()
  Getprivacypolicy()
  GetAdminReport()
  getAssignUser()
  getRoleData()
  setTimeout(()=>{
    setpop(false); 
   getresult();
    document.getElementById('remove').style.display = "block";
    document.getElementById('Tc-section-head').style.display = "block";
  
  },1000)
  
},[])


 
function getUser(){
  fetch('https://localhost:44312/Api/Tc/GetTcusers', {
    method:'GET',
    headers : {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },


  }).then(response => response.json())
  .then(data => {
    //console.log("Data",data)
    localStorage.setItem("Data", JSON.stringify(data));
  });
}

function getSectionData(){
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
 let UserId =  localStorage.getItem('UserId');

 const body ={
  
  id:UserId

 }
 console.log(body);


  axios({          
     method: "POST", 
     //url: `${BASE_URL}/Tc/EditSection`,      
     url: "https://localhost:44312/Api/Tc/Getsectiondata",
     data:body,
     headers: {             
       'Content-Type': 'application/json' , 
       'Authorization':bearer     
     }
   
   })
   .then((response) =>{
    console.log(response.data);
    localStorage.setItem("SectionData", JSON.stringify(response.data));
    setData(response.data)
    //setAbout(response.data)

     }) 
   
    }

    function GetTransactionhistory(){
     
      let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
      fetch('https://tclapi.thatscool.in/api/Admin/Total_TransactionHistory', {
       
      method:'GET',
    
        headers : {
    
          "Content-type": "application/json",
    
          "Accept": "application/json",
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
          'Authorization':bearer 
        },
    
      
    }).then(response => response.json())
    .then(data => {
    console.log("Data",data)
  
    localStorage.setItem("transData", JSON.stringify(data));

  
    });
  
    }
    function GetTermscondition(){
     
      fetch('https://localhost:44312/Api/Tc/GetTcTermsCondition', {
       
      method:'GET',
    
        headers : {
    
          "Content-type": "application/json",
    
          "Accept": "application/json",
    
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        },
    
  
  }).then(response => response.json())
  .then(data => {
  console.log("Data",data)
   
    localStorage.setItem("TermsData", JSON.stringify(data));
 
  });
  
 
  }

  function Getprivacypolicy(){
     
    fetch('https://localhost:44312/Api/Tc/GetTcPrivacypolicy', {
     
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        //"Authorization": bearer,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
 //body:JSON.stringify(data)

}).then(response => response.json())
.then(data => {
console.log("Data",data)
 
      localStorage.setItem("PrivacyPolicyData", JSON.stringify(data));

});

}

function GetAdminReport(){
     
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  fetch('https://tclapi.thatscool.in/api/Report/AdminReport', {
   
  method:'GET',
 
    headers : {

      "Content-type": "application/json",
      "Accept": "application/json",
      //"Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
      "Access-Control-Allow-Origin": "*",
      'Authorization':bearer 
    },

  
}).then(response => response.json())
.then(data => {
console.log("Data",data)

localStorage.setItem("TcReportData", JSON.stringify(data));

});

}

function getRoleData(){
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
 let UserRole =  localStorage.getItem("Role");

 const body ={
  
  role:UserRole

 }
 console.log(body);


  axios({          
     method: "POST", 
     //url: `${BASE_URL}/Tc/EditSection`,      
     url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
     data:body,
     headers: {             
       'Content-Type': 'application/json' , 
       'Authorization':bearer     
     }
   
   })
   .then((response) =>{
    console.log(response.data);
    localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
    
     }) 
   
    }

function getAssignUser(){
  
  fetch('https://localhost:44312/Api/Tc/GetAssignTcusers', {
    method:'GET',
    headers : {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },

    //body:JSON.stringify(data)

  }).then(response => response.json())
  .then(data => {
    console.log("Data",data)
   
    localStorage.setItem("TcAssignUsers", JSON.stringify(data));
  });
 
}

    function getresult(){
      
  let userrole = localStorage.getItem("RoleId");
console.log(userrole)
let roleId = userrole.includes("01");  
console.log(roleId)



/*---get section data ---*/


let Usersectiondata =  localStorage.getItem("SectionData");
//console.log(Usersectiondata)


let data =  JSON.parse(Usersectiondata);
 //console.log(data)

let sections = data&&data.map((item) => item.section);


   //console.log(sections)

   let sectionstr = sections.toString();
   console.log(sectionstr);
   
localStorage.setItem("sectionString",sectionstr)
   
  
let sectionresult =sectionstr.includes('Winner')
//console.log(sectionresult)
let sectionresultA =sectionstr.includes('AboutUs')
//console.log(sectionresultA)
let sectionresultB =sectionstr.includes('Terms&Conditions')
//console.log(sectionresultB)
let sectionresultC =sectionstr.includes('PrivacyPolicy')
//console.log(sectionresultC)
let sectionresultD =sectionstr.includes('Unfollow')
//console.log(sectionresultD)
let sectionresultE =sectionstr.includes('Report')
//console.log(sectionresultE)
let sectionresultF =sectionstr.includes('Transaction')
//console.log(sectionresultF)
// let sectionresultG =sectionstr.includes('')
// console.log(sectionresultG)
 

if(roleId==true&&sectionresult==false  && sectionresultA==false && sectionresultB==false && sectionresultC==false 
  && sectionresultD==false && sectionresultE==false &&sectionresultF==false){
 
     
    document.getElementById('Tc-touchMainA').style.display = "block";
    document.getElementById('Tc-touchMainB').style.display = "block";
    document.getElementById('Tc-touchMainC').style.display = "block";
    document.getElementById('Tc-touchMainD').style.display = "block";
    document.getElementById('Tc-touchMainE').style.display = "block";
    document.getElementById('Tc-touchMainF').style.display = "block";
    document.getElementById('Tc-touchMainG').style.display = "block";

 
}
else{
  document.getElementById('Tc-touchMainA').style.display = "none";
  document.getElementById('Tc-touchMainB').style.display = "none";
  document.getElementById('Tc-touchMainC').style.display = "none";
  document.getElementById('Tc-touchMainD').style.display = "none";
  document.getElementById('Tc-touchMainE').style.display = "none";
  document.getElementById('Tc-touchMainF').style.display = "none";
  document.getElementById('Tc-touchMainG').style.display = "none";
}


 if(roleId==false&&sectionresult==false  && sectionresultA==false && sectionresultB==false && sectionresultC==false 
  && sectionresultD==false && sectionresultE==false &&sectionresultF==false){
  
  document.getElementById('sectionspan').innerHTML = "Section Not Assigned";
  //document.getElementById('sectionspan').style.color="red"
}


  if( sectionresult==true){
 
    document.getElementById('Tc-touchMainA').style.display = "block";
   
  }
  // else{
  //   document.getElementById('Tc-touchMainA').style.display = "none";
  // }
  
  if( sectionresultA==true){
   
    document.getElementById('Tc-touchMainB').style.display = "block";
    
  }
  // else{
  //   document.getElementById('Tc-touchMainB').style.display = "none";
  // }
 

  if(sectionresultB==true ){
   
    document.getElementById('Tc-touchMainC').style.display = "block";
    
  }
  // else{
  //   document.getElementById('Tc-touchMainC').style.display = "none";
  // }
  
  if( sectionresultC==true ){
   
    document.getElementById('Tc-touchMainD').style.display = "block";
  }
  // else{
  //   document.getElementById('Tc-touchMainD').style.display = "none";
  // }
 
  if( sectionresultD==true ){
   
    document.getElementById('Tc-touchMainE').style.display = "block";
  }
  // else{
  //   document.getElementById('Tc-touchMainE').style.display = "none";
  // }
  
  if( sectionresultE==true){
   
    document.getElementById('Tc-touchMainF').style.display = "block";
  }
  // else{
  //   document.getElementById('Tc-touchMainF').style.display = "none";
  // }
  
  if( sectionresultF==true){
   
    document.getElementById('Tc-touchMainG').style.display = "block";
  }
  // else{
  //   document.getElementById('Tc-touchMainG').style.display = "none";
  // }
  
}


  return ( 
  
    <div className='TC-addmain'>
   <div className='Tc-addmainPic'>
 

<div className="TC-addgrid-layout">

  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Thats Cool'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span>Section Page</span>
    </div>
   
    </div>
 

 <div>
 {/* <div className='Tc-addmainPic'> */}
<div className='Tc-sectionMainList'>

<nav>

  <label for="Tc-touch" id="Tc-touchMain">
    
  <span id ="Tc-section-head" className='section'>Sections</span>
  </label>               
  <input type="checkbox" id="Tc-touch" /> 
   
    <ul className="left-right" id='remove'>
  
 

    <li>     
    <nav id="Tc-section-nav">

<label for="touchA" id="Tc-touchMainA" >

  <Link to="/TcWinner" class="left-right-link">
  <span class="left-right-item"><span class="left-word"><i class="fas fa-trophy"></i> </span>
  <span class="right-word" content="Winner">Winner</span></span></Link>
  </label>               

</nav> 
      </li> 
      
    <li>
    <nav id="Tc-section-nav">

<label for="Tc-touchB"  id="Tc-touchMainB">

<Link to="/TcAboutus" class="left-right-link"><span class="left-right-item">
  <span class="left-word"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
<span class="right-word" content="AboutUs">AboutUs</span></span></Link>
  </label>               


</nav> 
    </li>
  
    <li>
    <nav id="Tc-section-nav">

<label for="Tc-touchB"  id="Tc-touchMainC">

<Link to="/TcTerms" class="left-right-link"><span class="left-right-item"><span class="left-word"><i class="fa-solid fa-file-contract"></i> 
</span><span class="right-word" content="Terms & Conditions">Terms & Conditions</span></span></Link>
  </label>               


</nav> 
    </li>
   
    <li>
    <nav id="Tc-section-nav">

<label for="Tc-touchB"  id="Tc-touchMainD">

<Link to="/TcPrivacy" class="left-right-link"><span class="left-right-item"><span class="left-word"><i class="fa-solid fa-shield-halved"></i>
 </span><span class="right-word" content="Privacy Policy">Privacy Policy</span></span></Link>
  </label>               

</nav> 
    </li>
  
    <li>
    <nav id="Tc-section-nav">

<label for="Tc-touchB"  id="Tc-touchMainE">

<Link to="/TcUnfollow" class="left-right-link"><span class="left-right-item"><span class="left-word"><i class="fas fa-undo"></i>
 </span><span class="right-word" content="Unfollow">Unfollow</span></span></Link>
  </label>               
 
</nav> 
    </li>
  
    <li>
    <nav id="Tc-section-nav">

<label for="Tc-touchB"  id="Tc-touchMainF">

<Link to="/TcReport" class="left-right-link"><span class="left-right-item"><span class="left-word"><i class="fa fa-file" aria-hidden="true"></i> 
</span><span class="right-word" content="Report">Report</span></span></Link>
  </label>               

</nav> 
    </li>
    <li>
    <nav id="Tc-section-nav">

<label for="Tc-touchB"  id="Tc-touchMainG">

<Link to="/TcTransaction" class="left-right-link"><span class="left-right-item"><span class="left-word"><i class="fa fa-exchange" ></i>
 </span><span class="right-word" content="Transaction">Transaction</span></span></Link>
  </label>               

</nav> 
    </li>
  
  </ul>
  <span id='sectionspan'></span>
</nav> 

</div>
    {/* </div> */}
  
    {pop? <div id="Loader">

{/* <CircleLoader color="grey" /> */}
<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
    </div>
    </div>
    </div>
    
  )
}

export default Tcsectionmain
